import React, { useState } from "react";
import "./benefits.css";
import pointIcon1 from "../../assets/BenefitsSection/Boost Efficiency.svg";
import pointIcon2 from "../../assets/BenefitsSection/Reduce Errors.svg";
import pointIcon3 from "../../assets/BenefitsSection/Enhance Productivity.svg";
import pointIcon4 from "../../assets/BenefitsSection/Scalable & Flexible.svg";
import pointIcon5 from "../../assets/BenefitsSection/Cost-Effective.svg";
import benefitImage from "../../assets/BenefitsSection/benefit-image.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
export default function Benefits() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  const benefitsPoints = [
    {
      heading: "Boost Efficiency",
      paragraph:
        "Automate routine tasks and speed up workflows, allowing for faster and smoother operations.",
      icon: pointIcon1,
    },
    {
      heading: "Reduce Errors",
      paragraph:
        "Eliminate manual mistakes in UI interactions, ensuring accuracy and reliability in processes.",
      icon: pointIcon2,
    },
    {
      heading: "Enhance Productivity",
      paragraph:
        "Free up teams for higher-value tasks by automating repetitive work, improving overall output.",
      icon: pointIcon3,
    },
    {
      heading: "Scalable & Flexible",
      paragraph:
        "Works across multiple applications and industries, adapting to various business needs effortlessly.",
      icon: pointIcon4,
    },
    {
      heading: "Cost-Effective",
      paragraph:
        "Reduces operational expenses through AI-driven automation, optimizing resource utilization.",
      icon: pointIcon5,
    },
  ];

  const [activeTab, setActiveTab] = useState(0);

  return (
    <section
      className={`benefits-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="five"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Benefits</span>
          </div>
          <div className="heading-description">
            <h2>Smarter Automation, Greater Efficiency</h2>
            <p>Enhance Accuracy, Boost Productivity, and Reduce Costs</p>
          </div>
        </div>
        <div className="section-wrapper row">
          <div className="col-12 col-md-6">
            {" "}
            <div className="benefits-pointers">
              {benefitsPoints.map((point, index) => (
                <div
                  className={`benefit-point ${
                    activeTab === index ? "active" : ""
                  } point-${index + 1}`}
                  key={index}
                  onMouseOver={() => setActiveTab(index)}
                >
                  <img src={point.icon} alt="point-icon" />
                  <div className="benefit-point-text">
                    <h3>{point.heading}</h3>
                    <p>{point.paragraph}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-5">
            <div className="benefits-image">
              <img src={benefitImage} alt="benefit-img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
